import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import "../../../app.css";
import {
  MonitoringHubLogo,
  LeftArrow,
  LoginImage,
} from "../../../assets/images";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTrigger } from "react-bootstrap";
import { BASE_CORE_URL, UAPI_URL_AUTH } from "../../../config";

export default function Forgetpassword({ match }) {
  //#region useState start
  const [error, setError] = useState(null);
  const [isShowSuccessPage, setIsshowSuccessPage] = useState(false);
  const [isShowResetpasswordcomponent, setIsShowResetpasswordcomponent] =
    useState(true);
  //#endregion useState end

  //#region react Hooks start
  let history = useHistory();
  const location = useLocation();
  let t = location.pathname.split("/");
  let emailid = t[t.length - 1].replace('"', "").replace('"', "");
  //#endregion react Hooks end

  const Resetpasswordcomponent = ({ error }) => {
    const [email, setEmail] = useState(emailid);

    const emailIdChanged = (e) => {
      setEmail(e.target.value);
    };

    const successpagerender = async () => {
        console.log("emailid", email)
      if (email.trim() === "") {
        setError("Please enter email");
        return;
      }

      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      let frontendDomain = window.location.origin;
      const url = UAPI_URL_AUTH + "ForgotPassword?email=" + encodeURIComponent(email) + "&frontendDomain=" + frontendDomain;
      return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
          if (data.status == "success") {
            setIsshowSuccessPage(true);
            setIsShowResetpasswordcomponent(false);
          } else {
            setError("email not verified.");
          }
        })
        .catch(function (error) {
          setError("User does not exist!");
        });
    };

    return (
      <>
        <p className="ForgotPasswordName">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Back to Login</Tooltip>}
          >
            <img
              src={LeftArrow}
              alt="Back"
              onClick={() => history.replace("/login")}
            />
          </OverlayTrigger>
          <span className="ml-3"> Forgot your Password?</span>
        </p>
        <p className="SelectSpaceLine">
          {" "}
          Select which contact details should we use to reset your password:{" "}
        </p>

        <div className="inputMainContainer w25dot75rem">
          <div className="inputTypeLabelContainer">
            <label className="loginLabels" htmlFor="email1">
              Email ID
            </label>
            <input
              className="inputLoginType"
              id="email"
              type="email"
              placeholder="Ex. info@intellve.com"
              value={email}
              onChange={(e) => emailIdChanged(e)}
            />
          </div>
        </div>

        <div style={{ height: "10px" }}>
          <p className="Error_P">{error && <span>{error}</span>}</p>
        </div>
        <button
          className="ResetPasswordButton"
          style={{ marginTop: "30px" }}
          onClick={() => successpagerender()}
        >
          <span className="Manage-Configuration Sign-In">Reset Password</span>
        </button>
      </>
    );
  };

  const restpage = () => {
    setIsShowResetpasswordcomponent(true);
    setIsshowSuccessPage(false);
  };

  const Successpage = () => (
    <div className="SuccessfulPasswordDiv">
      <p className="ForgotPasswordName">
        <img src={LeftArrow} alt="Back" onClick={() => restpage()} />
        <span style={{ margin: "0px 0px 0px 5px" }} className="ml-3">
          Password reset link sent successful
        </span>
      </p>
      <p className="SelectSpaceLine mb-5">
        Password reset link has been sent to your registered email id. If you
        don't receive the link in the next 2 mins please go back & click on the
        reset password button again.
      </p>
      <button
        className="ResetPasswordButton"
        onClick={() => history.replace("/login")}
      >
        <span className="Manage-Configuration Sign-In">Sign In</span>
      </button>
    </div>
  );

  return (
    <div
      className="container-fluid forgot-pass-container"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="row forgot-pass-row">
        <div
          className="col-lg-6 col-md-6 col-sm-12 col-xs-12"
          style={{ backgroundColor: "#F6F8FC" }}
        >
          <div className="imageWhiteBg">
            <MonitoringHubLogo height={"70px"} />
          </div>
          <div className="BigImage">
            <img src={LoginImage} alt="Login" />
          </div>
        </div>
        <div className="col-lg-6 ContentForm col-md-6 col-sm-12 col-xs-12 login-col-2">
          <div className="WhiteFormSignIn">
            <div className="Content" id="resetpassworddiv">
              {isShowSuccessPage && <Successpage />}
              {isShowResetpasswordcomponent && (
                <Resetpasswordcomponent error={error} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
